import { render } from "./UnsubscribedSuccess.vue?vue&type=template&id=2ac40549&scoped=true"
import script from "./UnsubscribedSuccess.vue?vue&type=script&lang=js"
export * from "./UnsubscribedSuccess.vue?vue&type=script&lang=js"

import "./UnsubscribedSuccess.vue?vue&type=style&index=0&id=2ac40549&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ac40549"]])

export default __exports__